import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "./store/store"

export interface AccountSettingsState {
    openaiApiKey: string | null
}

const name = "accountSettingsSlice"
const initialState: AccountSettingsState = { openaiApiKey: null }

const accountSettingsSlice = createSlice({
    name,
    initialState,
    reducers: {
        setOpenAIKey: (state, action: PayloadAction<string>) => {
            state.openaiApiKey = action.payload
        },
        clearOpenAIKey: (state) => {
            state.openaiApiKey = null
        }
    }
})

export const { setOpenAIKey, clearOpenAIKey } = accountSettingsSlice.actions

export const selectOpenAIKey = (state: RootState) => state.accountSettings.openaiApiKey

export default accountSettingsSlice.reducer
